module.exports = __webpack_public_path__ + "img/avatar06.fcae57c6.jpg";